













import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

import {
  SimpleStyleList,
} from '@/types';

@Component
export default class InfoBadge extends Vue {
  @Prop(String)
  public readonly text!: string;

  @Prop({ type: String, default: '#6e6e6e' })
  public readonly color!: string;

  get colorStyles(): SimpleStyleList {
    return {
      color: this.color,
    };
  }
}
